import React from 'react'
import { FilterBody, FilterBodyBase, FilterBodyTitle, FilterItem, FilterLabel } from './FilterBody.styles'
import FilterItemContainer from './FilterItem.container'

import PresetFiltersContainer from '../PresetFilters/PresetFilters.container'
import Typestack from '../../../typestack'

const FilterBodyComponent = ({ analytics, filters, extraFilters, appliedFilters, api, savedFilters, quickFilters, setAllFilters, addAppliedFilter, handleRemoveFilter, i18n, handleRemove, handleInputValidationErrors }) => {
  return (
    <FilterBodyBase>
      <PresetFiltersContainer
        analytics={analytics}
        api={api}
        i18n={i18n}
        savedFilters={savedFilters}
        quickFilters={quickFilters}
        setAllFilters={setAllFilters}
        handleRemove={handleRemove}
      />

      <FilterBodyTitle>
        <Typestack type='eyebrow' style={{ color: 'rgba(0, 0, 0, 0.85)' }}>
          {i18n.columnFilters}
        </Typestack>
      </FilterBodyTitle>

      <FilterBody data-testid='filters-body-container'>
        {
          filters.map((filterItem, i) => {
            let config = filterItem

            if (Array.isArray(filterItem)) {
              config = filterItem[0]
            }
            if (config.type === 'autoselect') {
              config.type = 'select'
            }
            const handle = 'bodyfilter_' + config.type + '_' + config.column

            let values = null

            // get values from applied filter is one is appropriate for this filter
            if (appliedFilters[handle]) {
              values = appliedFilters[handle].values
            }

            return (
              <FilterItem key={'filter_item' + i}>
                <FilterLabel>{config.filterTitle}</FilterLabel>
                <FilterItemContainer
                  addAppliedFilter={addAppliedFilter}
                  handleRemoveFilter={handleRemoveFilter}
                  config={config}
                  api={api}
                  i18n={i18n}
                  handle={handle}
                  values={values}
                  handleInputValidationErrors={handleInputValidationErrors}
                />
              </FilterItem>
            )
          })
        }
      </FilterBody>

      {extraFilters && extraFilters.filters.length > 0 &&
        <div>
          <div style={{ marginBottom: '20px' }}>
            <Typestack type='eyebrow' style={{ color: 'rgba(0, 0, 0, 0.85)' }}>
              {i18n.extraFilters}
            </Typestack>
          </div>

          <FilterBody data-testid='extra-filters-body-container'>
            {
              extraFilters.filters.map((filterItem, i) => {
                let config = filterItem

                if (Array.isArray(filterItem)) {
                  config = filterItem[0]
                }

                const handle = 'bodyfilter_' + config.type + '_' + config.column

                let values = null

                // get values from applied filter is one is appropriate for this filter
                if (appliedFilters[handle]) {
                  values = appliedFilters[handle].values
                }

                return (
                  <FilterItem key={'filter_item' + i}>
                    <FilterLabel>{config.title}</FilterLabel>
                    <FilterItemContainer
                      addAppliedFilter={addAppliedFilter}
                      handleRemoveFilter={handleRemoveFilter}
                      config={config}
                      api={api}
                      i18n={i18n}
                      handle={handle}
                      values={values}
                      handleInputValidationErrors={handleInputValidationErrors}
                    />
                  </FilterItem>
                )
              })
            }
          </FilterBody>
        </div>
      }

    </FilterBodyBase>
  )
}

export default FilterBodyComponent
